<template>
  <div class="sparkline">
    <trend
      :data="points"
      :gradient="['#683090', '#c97eff']"
      :height="height"
      :auto-draw="autoDraw"
    />
  </div>
</template>

<script>
import Trend from 'vuetrend';

export default {
  components: { Trend },
  props: {
    points: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 40,
    },
    autoDraw: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// Trend.vue?b4f07922